export default __webpack_public_path__ + "static/media/logo.9575c978.png";